import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '../store'
import { useAuthStore } from '@/stores/auth.store'

const allUser: string[] = ['admin', 'developer', 'user', 'no']
const onlySignedIn: string[] = ['admin', 'developer', 'user']
const onlyAdmins: string[] = ['admin', 'developer']
const onlyDeveloper: string[] = ['developer']

const routes: Array<RouteRecordRaw> = [
	{
		path: '/alerts',
		name: 'Alerts',
		component: () => import(/* webpackChunkName: "alerts" */ '@/features/alerts/AlertsView.vue'),
		// meta: { group: "main", allowedRoles: onlySignedIn }
		meta: { group: '', allowedRoles: onlyAdmins },
	},

	// {
	// 	path: '/logout',
	// 	name: 'Logout',
	// 	component: () => import(/* webpackChunkName: "alerts" */ '../views/____Logout.vue'),
	// 	// meta: { group: "main", allowedRoles: onlySignedIn }
	// 	meta: { group: '', allowedRoles: allUser },
	// },

	{
		path: '/',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		name: 'Home',
		component: () => import(/* webpackChunkName: "home" */ '@/features/system/HomeView.vue'),
		// meta: { group: "main", allowedRoles: onlySignedIn }
		meta: { group: 'base', allowedRoles: onlySignedIn, icon: 'mapmarker' }, // is always visible
	},

	{
		path: '/about',
		name: 'About',
		component: () => import(/* webpackChunkName: "about" */ '@/features/system/____AboutView.vue'),
		meta: { group: '', allowedRoles: onlySignedIn, layoutComponent: 'MainLayout' },
	},
	{
		path: '/signin',
		name: 'SignIn',
		component: () => import(/* webpackChunkName: "signIn" */ '@/features/auth/SignInView.vue'),
		meta: { group: '', allowedRoles: allUser, layoutComponent: 'MainLayout' },
	},
	{
		path: '/users',
		name: 'Users',
		component: () => import(/* webpackChunkName: "users" */ '@/features/users/UsersView.vue'),
		meta: { group: 'admin', allowedRoles: onlyAdmins, icon: 'users' },
	},
	{
		path: '/userprofile',
		name: 'AuthUserProfile',
		component: () => import(/* webpackChunkName: "user" */ '@/features/auth/AuthUserProfileView.vue'),
		meta: { group: 'base', allowedRoles: onlySignedIn, icon: 'user' },
	},
	{
		path: '/projects',
		name: 'Projects',
		component: () => import(/* webpackChunkName: "projects" */ '@/features/projects/ProjectListView.vue'),
		// meta: { group: "admin", allowedRoles: onlySignedIn, }
		meta: { group: 'base', allowedRoles: onlySignedIn, icon: 'list' },
		// meta: { group: "", allowedRoles: onlySignedIn, }
	},
	{
		path: '/projects/:projectId',
		name: 'Project',
		component: () => import(/* webpackChunkName: "project" */ '@/features/projects/ProjectView.vue'),
		meta: { group: '', allowedRoles: onlySignedIn, checkAccessProject: true },
	},
	{
		path: '/yocto/',
		name: 'Yocto',
		component: () => import(/* webpackChunkName: "project" */ '@/features/admin/____YoctoView.vue'),
		meta: { group: 'developer', allowedRoles: onlyAdmins, icon: 'ws' },
	},
	{
		path: '/locations',
		name: 'Locations',
		component: () =>
			// import(/* webpackChunkName: "locations" */ '@/features/locations/____old/____LocationsView.vue'),
			import(/* webpackChunkName: "locations" */ '@/features/locations/LocationList.vue'),
		meta: { group: 'base', allowedRoles: onlySignedIn, icon: 'locations' },
		// meta: { group: "", allowedRoles: onlySignedIn }
	},
	{
		path: '/location/:locationId',
		name: 'Location',
		component: () => import(/* webpackChunkName: "location" */ '@/features/locations/LocationView.vue'),
		meta: { group: '', allowedRoles: onlySignedIn },
	},
	// {
	// 	path: '/',
	// 	name: 'Location',
	// 	component: () => import(/* webpackChunkName: "location" */ '@/features/chart/CustomGraphSettings/CustomGraphDataView.vue'),
	// 	meta: { group: '', allowedRoles: onlySignedIn },
	// },
	{
		path: '/modules',
		name: 'Modules',
		component: () => import(/* webpackChunkName: "modules" */ '@/features/moduls/ModulesView.vue'),
		meta: { group: '', allowedRoles: onlySignedIn },
	},
	{
		path: '/hubs',
		name: 'Hubs',
		component: () => import(/* webpackChunkName: "hubs" */ '@/features/hubs/HubListView.vue'),
		meta: { group: 'base', allowedRoles: onlySignedIn, icon: 'hub' },
	},
	{
		path: '/hub/:hubId',
		name: 'Hub',
		component: () => import(/* webpackChunkName: "hub" */ '@/features/hubs/HubView.vue'),
		// component: () => import(/* webpackChunkName: "hub" */ "../views/HubLogs.vue"),
		meta: { group: '', allowedRoles: onlySignedIn, icon: 'hub' },
	},
	{
		path: '/comapp',
		name: 'Comapps',
		component: () => import(/* webpackChunkName: "comapps" */ '@/features/comapps/ComappsView.vue'),
		// meta: { group: "main", allowedRoles: onlyAdmins }
		meta: { group: 'admin', allowedRoles: onlyAdmins, icon: 'comapp' },
	},

	// {
	//   path: "/cgalerts",
	//   name: "GraphAlerts",
	//   component: () => import(/* webpackChunkName: "alerts" */ "../views/GraphAlerts.vue"),
	//   // meta: { group: "main", allowedRoles: onlySignedIn }
	//   meta: { group: "admin", allowedRoles: onlyAdmins }
	// },

	{
		path: '/alertmatrix/user',
		name: 'AlertMatrixByUser',
		component: () => import(/* webpackChunkName: "alerts" */ '@/features/alerts/AlertMatrixByUser.vue'),
		// meta: { group: "main", allowedRoles: onlySignedIn }
		meta: { group: 'admin', allowedRoles: onlyAdmins, icon: 'alerts' },
	},
	{
		path: '/alertmatrix/graphs',
		name: 'AlertMatrixForGraphs',
		component: () => import(/* webpackChunkName: "alerts" */ '@/features/alerts/AlertMatrixForGraphs.vue'),
		// meta: { group: "main", allowedRoles: onlySignedIn }
		meta: { group: 'admin', allowedRoles: onlyAdmins, icon: 'alerts' },
	},

	{
		path: '/inventory',
		name: 'Inventory',
		component: () => import(/* webpackChunkName: "alerts" */ '@/features/inventory/InventoryView.vue'),
		// meta: { group: "main", allowedRoles: onlySignedIn }
		meta: { group: 'admin', allowedRoles: onlyAdmins, icon: 'inventory' },
	},

	{
		path: '/comapp/:comappId',
		name: 'Comapp',
		component: () => import(/* webpackChunkName: "comapp" */ '@/features/comapps/ComappView.vue'),
		meta: { group: '', allowedRoles: onlyAdmins },
	},
	// {
	// 	path: "/modules/:modulId",
	// 	name: "Module",
	// 	component: () => import(/* webpackChunkName: "module" */ "../views/Module.vue"),
	// 	meta: { group: "", allowedRoles: onlySignedIn }
	// },
	{
		// path: "/modules/:hubId/:modulId",
		// path: "/modules/:hubLocId/:modulId",
		// path: '/modules/:hubLocProId/:modulId',
		path: '/modules/:moduleId',
		name: 'Module',
		component: () => import(/* webpackChunkName: "module" */ '@/features/moduls/ModuleView.vue'),
		meta: { group: '', allowedRoles: onlySignedIn },
	},

	// {
	// 	// path: "/modules/:hubId/:modulId",
	// 	// path: "/modules/:hubLocId/:modulId",
	// 	path: '/chart/:hubLocProId/:moduleId',
	// 	name: 'Chart',
	// 	component: () => import(/* webpackChunkName: "module" */ '@/features/moduls/____old/____ModuleV2View.vue'),
	// 	meta: { group: '', allowedRoles: onlySignedIn },
	// },

	{
		path: '/graphs',
		name: 'Graphs',
		// component: () => import(/* webpackChunkName: "newgraph" */ '@/features/customGraphs/NewGraphView.vue'),
		component: () =>
			import(/* webpackChunkName: "newgraph" */ '@/features/chart/CustomGraphSettings/CustomGraphListView.vue'),
		meta: { group: 'base', allowedRoles: onlyAdmins, icon: 'graphs' },
	},
	{
		path: '/newgraph',
		name: 'NewGraph',
		// component: () => import(/* webpackChunkName: "newgraph" */ '@/features/customGraphs/NewGraphView.vue'),
		component: () =>
			import(/* webpackChunkName: "newgraph" */ '@/features/chart/CustomGraphSettings/CustomGraphDataView.vue'),
		meta: { group: '', allowedRoles: onlyAdmins },
	},

	// {
	// 	path: "/customgraph",
	// 	name: "CustomGraph",
	// 	component: () => import(/* webpackChunkName: "customgraph" */ "../views/CustomGraph.vue"),
	// 	meta: { group: "", allowedRoles: onlyAdmins }
	// },

	{
		path: '/ipcalls',
		name: 'IPCalls',

		component: () => import(/* webpackChunkName: "ipcalls" */ '@/features/admin/IPCallsView.vue'),
		meta: { group: 'developer', allowedRoles: onlyDeveloper, icon: 'ipcalls' },
	},

	{
		path: '/admin',
		name: 'Admin',
		component: () => import(/* webpackChunkName: "admin" */ '@/features/admin/AdminView.vue'),
		meta: { group: 'developer', allowedRoles: onlyDeveloper, icon: 'admin' },
	},

	{
		path: '/changelogs',
		name: 'ChangeLogs',
		component: () => import(/* webpackChunkName: "changelogs" */ '@/features/system/____ChangeLogsView.vue'),
		meta: { group: 'admin', allowedRoles: onlyAdmins, icon: 'changelogs' },
	},
]

const router: any = createRouter({
	// history: createWebHistory(process.env.BASE_URL),
	history: createWebHistory('/'),
	routes,
})

router.beforeEach((to: any, from: any, next) => {
	const user = useAuthStore().user
	const role = user?.role || 'no'
	const accessProjects = user?.accessProjects || []
	// const role = store.state.user?.role || 'no'
	// const accessProjects = store.state.user?.accessProjects || []
	const allowed = to.meta.allowedRoles || []
	const checkAccessProject = !!to.meta.checkAccessProject
	const isAdmin = ['admin', 'developer'].includes(role)

	if (allowed.includes(role))
		if (checkAccessProject) {
			// console.log(k);
			if (isAdmin) return next()
			else if (accessProjects.includes(to.params.projectId)) return next()
			else console.log('no access!')
		} else {
			// no role actually given:
			if (to.path.includes('signin')) return next()
			else return next()
		}
	else if (role === 'no') {
		return next({ path: '/signin', query: { redirect: to.path } })
	}
})

export default router
